import { MeshSpectrum } from '@beatflyer/shaders-lib';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { CustomPropertyRow } from '../CustomPropertyRow';
import { isPickingColor } from 'utils';

interface Props {
  trigger: HTMLElement | null;
  mesh: MeshSpectrum;
  onChange: (prop: string, value: any) => void;
  onClose: () => void;
}

export class SoundWaveSettingsPopover extends React.Component<Props> {
  componentDidMount() {
    this.reposition();
    window.addEventListener('mousedown', this.didClickOnWindow, true);
  }

  reposition() {
    if (this.props.trigger) {
      const box = this.props.trigger.getBoundingClientRect();
      const me = ReactDOM.findDOMNode(this) as HTMLElement;
      const top = Math.min(
        box.top - 9,
        window.innerHeight - me.getBoundingClientRect().height
      );
      me.style.left = box.right + 'px';
      me.style.top = top + 'px';
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.didClickOnWindow, true);
  }

  didClickOnWindow = (e: MouseEvent) => {
    if (isPickingColor()) {
      return;
    }
    const me = ReactDOM.findDOMNode(this) as Element;
    if (!me.contains(e.target as HTMLElement)) {
      this.props.onClose();
    }
  };

  componentDidUpdate() {
    if (!isPickingColor()) {
      // TODO: be more selective when reposition?
      this.reposition();
    }
  }

  // onCustomPropertyChange = (prop: string, value: any) => {
  //   // console.log( this.props.data.constructor.label + '.' + prop + ': ' + value );
  //   this.props.mesh.setProperty(prop, value);
  //   this.props.onChange();
  //   if (prop === 'color') {
  //     this.props.onChangeColor();
  //   }
  // };

  render() {
    const { mesh } = this.props;
    const customProperties: JSX.Element[] = [];
    const properties = mesh.getPropertiesDescriptors();
    const createNode = (key: string) => {
      if (['left', 'top', 'right', 'bottom'].includes(key)) {
        return;
      }
      const p = properties[key];
      const label = p.label || key;
      let shouldBeVisible = true;
      if (p.shouldBeVisible) {
        shouldBeVisible = p.shouldBeVisible.call(this.props.mesh);
      }
      if (shouldBeVisible) {
        customProperties.push(
          <CustomPropertyRow
            name={label}
            id={key}
            key={key}
            value={mesh.getProperty(key)}
            data={p}
            onChange={this.props.onChange}
          />
        );
      }
    };
    for (var k in properties) {
      createNode(k);
    }
    return (
      <div className="sound-wave-popover frame-settings-popover">
        <div className="effect-properties">{customProperties}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/settings-popovers/SoundWaveSettingsPopover.tsx